export default "__VITE_ASSET__D1WLkE2M__"